import './scripts/block-columns/block-columns';
import './scripts/block-contact/block-contact';
import './scripts/block-text-media/block-text-media';
import './scripts/block-homepage-hero/block-homepage-hero';
import './scripts/block-case-study-hero/block-case-study-hero';
import './scripts/block-logos/block-logos';
import './scripts/block-video/block-video';
import './scripts/block-showcase/block-showcase';
import './scripts/block-contact-hero/block-contact-hero';
import './scripts/block-showcase-carousel/block-showcase-carousel';
import './scripts/block-quote/block-quote';
import './scripts/block-container/block-container';
import './scripts/component-simple-columns/component-simple-columns';
import './scripts/block-statistics/block-statistics';
import './scripts/navigation/navigation';
import './scripts/global';
